import React, { Fragment, useContext, useEffect, useRef, useState } from "react";
import ScheduledTrips from "./ScheduledTrips";
import { Container, Row, Col } from "reactstrap";
import { Breadcrumbs } from "../../../AbstractElements";
import BookingsAccepted from "./BookingsAccepted";
import TripCancelationAlertsTable from "./TripCancelationAlertsTable";
import ScheduledTripsTable from "./ScheduledTripsTable";
import OnlineCabs from "./OnlineCabs";
import DetailsMap from "./DetailsMap";
import TripDetails from "./TripDetails";
import CurrentUnassignedTripsTable from "./CurrentUnassignedTripsTable";
import DashboardCards from "./DashboardCards";
import Adhoc_car from "../../../assets/icons/adhoc_car.svg";
import DestinationTracking from "../../../assets/icons/destination_tracking.svg";
import ExtendedTrips from "../../../assets/icons/executed_trips.svg";
import nonFullfilledTrips from "../../../assets/icons/nonfulfiled_trips.svg";
import onTripCabs from "../../../assets/icons/ontrip_cabs.svg";
import onlineDrivers from "../../../assets/icons/online_drivers.svg";
import offlineCabs from "../../../assets/icons/offline_cabs.svg";
import ManualTrip from "../../../assets/icons/Layer 1.svg";
import destinationCircle from "../../../assets/icons/destination_circle.svg";
import executedCircle from "../../../assets/icons/executetd_tripscrcle.svg";
import nonFullfilledTripsCircle from "../../../assets/icons/non_fulfilled_trips_circle.svg";
import offlineCabsCircle from "../../../assets/icons/offline_circle.svg";
import onlineDriversCircle from "../../../assets/icons/onlinedrivers_circle.svg";
import onTripCircle from "../../../assets/icons/ontrip_circle.svg";
import adhocCircle from "../../../assets/icons/adhoc_circle.svg";
import ManualCircle from "../../../assets/icons/Group 10142.svg";
import {
  getAggregators,
  getDashboardCount,
  getOnTripDetails,
} from "../../../Services/DispatchDashboard.service";
import { getDriverTypes } from "../../../Services/Driver.service";
import CreateDriver from "./CreateDriver";
import SharedDataContext from "../../../_helper/SharedData";
import { formatDateTime } from "../../../Services/Shared.service";
import moment from "moment";
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'

const dashboardCardData = [
  {
    title: "Destination Tracking",
    subtitle: "Airport to City",
    backgroundColor: "#EFE6F9",
    icon: <img src={DestinationTracking} alt="Destination Tracking" />,
    circleIcon: destinationCircle,
    key: "airportToCity",
    isCursorHovered: true
  },
  {
    title: "Executed Trips",
    backgroundColor: "#AFDFDD",
    icon: <img src={ExtendedTrips} alt="Executed Trips" />,
    circleIcon: executedCircle,
    key: "executedTrips",
    isCursorHovered: true
  },
  {
    title: "Non Fulfilled Trips",
    backgroundColor: "#CAD0F9",
    icon: <img src={nonFullfilledTrips} alt="Non Fulfilled Trips" />,
    circleIcon: nonFullfilledTripsCircle,
    key: "nonFullFilledTrips",
    isCursorHovered: true
  },
  {
    title: "Adhoc",
    backgroundColor: "#CFCFCF",
    icon: <img src={Adhoc_car} alt="Adhoc" />,
    circleIcon: adhocCircle,
    value: "+",
    isCursorHovered: true
  },
  {
    title: "On Trip Cabs",
    backgroundColor: "#FFDAE5",
    icon: <img src={onTripCabs} alt="On Trip Cabs" />,
    circleIcon: onTripCircle,
    key: "onTripCabs",
    isCursorHovered: true
  },
  {
    title: "Online Drivers",
    backgroundColor: "#FFEDAE",
    icon: <img src={onlineDrivers} alt="Online Drivers" />,
    circleIcon: onlineDriversCircle,
    key: "onLineDrivers",
    isCursorHovered: true
  },
  {
    title: "Zone Capture",
    backgroundColor: "#B7E6EE",
    icon: <img src={DestinationTracking} alt="Destination Tracking" />,
    circleIcon: offlineCabsCircle,
    key: "zoneCaptureCount",
    isCursorHovered: true
  },
  {
    title: "Manual Trips",
    backgroundColor: "#F29F8F",
    icon: <img src={ManualTrip} alt="Manual Trips" />,
    circleIcon: ManualCircle,
    key: "manualTrips",
    isCursorHovered: true
  },
];
const DispatchDashboard = () => {
  const { cityData, globalCityField, setShowApiLoader, dateFilter } =
    useContext(SharedDataContext);
  const [createDriverModal, setCreateDriverModal] = useState(false);
  const toggleCreateDriverModal = () =>
    setCreateDriverModal(!createDriverModal);

  const [onClickFlag, setOnClickFlag] = useState(false);

  const [aggregatorList, setAggregatorList] = useState([]);

  const [driverTypeList, setDriverTypeList] = useState([]);

  const [dashboardCount, setDashboardCount] = useState([]);

  const [onTripDetails, setOnTripDetails] = useState([]);

  const [mapClickData, setMapClickData] = useState({});

  const [dashboardCardsLoader, setDashboardCardsLoader] = useState(false);

  const localFromDate = moment(dateFilter.startDate).set({ h: 0, m: 0, s: 0, ms: 0 });
  const localToDate = moment(dateFilter.endDate).set({ h: 23, m: 59, s: 59, ms: 999 });
  const FormatFromDate = formatDateTime(
    localFromDate,
    "YYYY-MM-DD"
  );
  const FormatToDate = formatDateTime(localToDate, "YYYY-MM-DD");
  const firstUpdate = useRef(true);

  useEffect(() => {
    getAggregators().then((result) => {
      if (result.data) {
        const data = result.data.map((element) => {
          return {
            label: element.companyName,
            value: element,
          };
        });
        setAggregatorList(data);
      }
    });
    getDriverTypes().then((result) => {
      if (result.data) {
        const data = result.data.map((element) => {
          return {
            label: element.name,
            value: element,
          };
        });
        setDriverTypeList(data);
      }
    });
  }, []);

  useEffect(() => {
    setDashboardCardsLoader(true)
    const serviceCityId = globalCityField?.value?.id || null;
    let onTripObj = {
      serviceCityId: serviceCityId || 0,
    };
    getOnTripDetails(onTripObj).then((result) => {
      console.log(result.data, "result.data");
      if (result.data) {
        setOnTripDetails(result.data);
      }
    });

    let body = {
      serviceCityId: serviceCityId,
      fromDate: FormatFromDate,
      toDate: FormatToDate,
    };

    getDashboardCount(body)
      .then((result) => {
        setDashboardCardsLoader(false)
        if (result.data) {
          console.log(result.data, "result.datatat");
          setDashboardCount(result.data);
        }
      })
      .catch((err) => {
        setDashboardCardsLoader(false)
      });
  }, [globalCityField.value]);

  useEffect(() => {
    if (firstUpdate.current) {
      firstUpdate.current = false;
      return;
    }
    const serviceCityId = globalCityField?.value?.id || null;
    let onTripObj = {
      serviceCityId: serviceCityId || 0,
    };
    getOnTripDetails(onTripObj).then((result) => {
      console.log(result.data, "result.data");
      if (result.data) {
        setOnTripDetails(result.data);
      }
    });

    let body = {
      serviceCityId: serviceCityId,
      fromDate: FormatFromDate,
      toDate: FormatToDate,
    };
    setDashboardCardsLoader(true)
    getDashboardCount(body)
      .then((result) => {
        setDashboardCardsLoader(false)
        if (result.data) {
          console.log(result.data, "result.datatat");
          setDashboardCount(result.data);
        }
      })
      .catch((err) => {
        setDashboardCardsLoader(false)
      });
  }, [dateFilter.startDate, dateFilter.endDate])

  return (
    <Fragment>
      <Breadcrumbs parent="Dashboard" mainTitle="Dashboard" />
      <Container fluid={true}>
        <Row className="dispatch-dashboard">
          <Col xl="12">
            <Row>
              {dashboardCardData.map((element) => {
                let obj = { ...element };
                if (element.key) {
                  obj["value"] =
                    dashboardCount[element.key] ||
                      dashboardCount[element.key] == 0
                      ? dashboardCount[element.key]
                      : "N/A";
                    
                }

                return (
                  <Col xl="3">
                    {dashboardCardsLoader ?
                      <Skeleton className="dispatch-dashboard-data-card" />
                      : <DashboardCards
                        element={obj}
                        toggleCreateDriverModal={toggleCreateDriverModal}
                      />}
                  </Col>
                );
              })}
            </Row>
          </Col>
          <Col xl="12">
            <Row>
              <Col xl="4">
                <ScheduledTrips globalCityField={globalCityField} />
              </Col>
              <Col xl="4">
                <BookingsAccepted globalCityField={globalCityField} />
              </Col>
              <Col xl="4">
                <TripCancelationAlertsTable globalCityField={globalCityField} />
              </Col>
            </Row>
          </Col>

          <Col xl="7">
            <ScheduledTripsTable
              cityData={cityData}
              globalCityField={globalCityField}
              setShowApiLoader={setShowApiLoader}
            />
          </Col>
          <Col xl="5">
            <OnlineCabs cityData={cityData} />
          </Col>

          <Col xl="12">
            <Row>
              <Col lg="8" sm="12">
                <DetailsMap
                  setOnClickFlag={setOnClickFlag}
                  setMapClickData={setMapClickData}
                  mapClickData={mapClickData}
                  onTripDetails={onTripDetails}
                  globalCityField={globalCityField}
                />
              </Col>
              <Col lg="4" sm="12">
                <TripDetails
                  onClickFlag={onClickFlag}
                  mapClickData={mapClickData}
                />
              </Col>
            </Row>
          </Col>
          <Col xl="12">
            <CurrentUnassignedTripsTable globalCityField={globalCityField} />
          </Col>
        </Row>
      </Container>
      <CreateDriver
        Large={createDriverModal}
        title={"Create Driver"}
        LargeModaltoggle={toggleCreateDriverModal}
        aggregatorList={aggregatorList}
        driverTypeList={driverTypeList}
        cityDataList={cityData}
        setShowApiLoader={setShowApiLoader}
      />
    </Fragment>
  );
};

export default DispatchDashboard;
